import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const before = ['Pasas horas armando material desde cero.', 'Buscas recursos sueltos que no siempre sirven.', 'Improvisas evaluaciones a último momento.', 'Sientes que nunca alcanza el tiempo.'];
const after = ['Todo el año planificado y listo para dar.', 'Teoría, actividades y laboratorios en un solo lugar.', 'Evaluaciones con solucionario incluidas.', 'Recuperas tus horas y das clases de calidad.'];
const highlights: [string, string][] = [['500+', 'ACTIVIDADES'], ['6', 'AÑOS CUBIERTOS'], ['100%', 'LISTO PARA USAR']];
export function TransformationSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-179" data-mp="298ukcav5hsu4">
      <Reveal className="mx-auto max-w-5xl" data-id="element-180" data-mp="2968csb89fdbw">
        <div className="mx-auto max-w-3xl text-center" data-id="element-181" data-mp="247x443tpb8v9">
          <p className="mb-4 text-xs font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-182" data-mp="207d5evthbx70">UNA MEJOR FORMA DE ENSEÑAR CIENCIA</p>
          <h2 className="text-4xl font-black leading-[1.08] tracking-tight text-brand-blue md:text-5xl" data-id="element-183" data-mp="fakhlu37smyc">
            De un docente agotado a un <span className="italic text-brand-purple" data-id="element-184" data-mp="k3dk0bb7nj79">guía de ciencia seguro.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-185" data-mp="5ehd4hkw4c88">
            El futuro de tus clases no debería costarte noches enteras preparando material. Con Física y Química Lista tienes todo
            resuelto: abres, imprimes y enseñas con confianza.
          </p>
        </div>

        <div className="mx-auto my-12 grid max-w-3xl divide-y divide-brand-dark overflow-hidden rounded-2xl border border-brand-dark bg-brand-alt shadow-sm sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-186" data-mp="12ykdf8fdv3js">
          {highlights.map(([value, label]) => <div key={label} className="px-5 py-5 text-center" data-id="element-187" data-mp="39qux0035jncl">
              <strong className="block font-serif text-3xl leading-none text-brand-orange" data-id="element-188" data-mp="3dsq1fdgdqgul">{value}</strong>
              <span className="mt-2 block text-[10px] font-extrabold leading-tight tracking-[0.08em] text-brand-gray" data-id="element-189" data-mp="1k9ppkq0x7gje">{label}</span>
            </div>)}
        </div>

        <div className="overflow-hidden rounded-3xl border border-brand-dark bg-brand-alt shadow-[0_18px_45px_rgba(22,56,107,0.10)]" data-id="element-190" data-mp="1fcz6ruxqe6ua">
          <div className="grid md:grid-cols-2" data-id="element-191" data-mp="15lmj7fiyu2u2">
            <Comparison title="ANTES" items={before} positive={false} data-id="element-192" data-mp="15kt8k3gvyt6n" />
            <Comparison title="CON FÍSICA Y QUÍMICA LISTA" items={after} positive data-id="element-193" data-mp="11kizghxsrmnk" />
          </div>
          <div className="border-t border-brand-dark bg-brand-main px-6 py-4 text-center text-xs font-semibold text-brand-gray" data-id="element-194" data-mp="wjd5yhwbbvcz">
            Un plan completo para preparar menos y enseñar ciencia con más confianza.
          </div>
        </div>
      </Reveal>
    </section>;
}
function Comparison({
  title,
  items,
  positive
}: {
  title: string;
  items: string[];
  positive: boolean;
}) {
  const Icon = positive ? CheckCircle2Icon : XCircleIcon;
  return <div className={`p-6 md:p-9 ${positive ? 'border-t border-brand-dark bg-brand-alt md:border-l md:border-t-0' : 'bg-[#f5f0e8]'}`} data-id="element-195" data-mp="2gyf3645ilmzk">
      <div className="mb-7 flex items-start justify-between gap-4" data-id="element-196" data-mp="2ti2cst9drrc3">
        <div data-id="element-197" data-mp="2y9ke5ifbftxl">
          <p className={`text-[10px] font-extrabold tracking-[0.16em] ${positive ? 'text-brand-teal' : 'text-brand-gray'}`} data-id="element-198" data-mp="2y92ai0qbqdfn">
            {positive ? 'EL SISTEMA LISTO PARA ENSEÑAR' : 'EL COSTO DE EMPEZAR DESDE CERO'}
          </p>
          <h3 className="mt-2 font-serif text-2xl font-bold tracking-tight text-brand-blue" data-id="element-199" data-mp="26jpp7mvde69g">{title}</h3>
        </div>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-teal text-white shadow-md' : 'bg-brand-alt text-brand-gray'}`} data-id="element-200" data-mp="2ak9n4snrpdwn">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-201" data-mp="2kjqncuk92zl8" />
        </div>
      </div>
      <ul className="space-y-2.5" data-id="element-202" data-mp="3qxg8whlbrbrq">
        {items.map(item => <li key={item} className={`flex items-center gap-3 rounded-xl px-3 py-3 ${positive ? 'bg-brand-main' : 'bg-brand-alt/70'}`} data-id="element-203" data-mp="3vx2q1249xc5t">
            <Icon className={`h-4 w-4 shrink-0 ${positive ? 'text-brand-teal' : 'text-brand-gray'}`} aria-hidden="true" data-id="element-204" data-mp="18qq3slq86qh9" />
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-brand-text' : 'text-brand-gray'}`} data-id="element-205" data-mp="1hpbjm94bbrec">{item}</span>
          </li>)}
      </ul>
    </div>;
}